import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
import mediaFullSchema from '@utils/validate/blocksSchemes//mediaFullSchema';
const categorySliderWithnavSlideSchema = Joi.object({
  verticalPosition: Joi.string().required(),
  horizontalPosition: Joi.string().required(),
  title: Joi.string().allow('', null).required(),
  shortTitle: Joi.string().allow('', null).required(),
  image: mediaUrlSchema.required(),
  imageWithBlur: imagesWithBlurSchema,
  video: mediaFullSchema(true),
  id: Joi.number().required(),
  textColor: Joi.allow(),
  buttonVariant: Joi.string().allow('', null).required(),
  buttonUrl: Joi.allow()
}).unknown(true);
export default categorySliderWithnavSlideSchema;